import {checkLoadButton} from "./checkLoadButton";
import {clearList} from './clearList';
import {initLazyImages} from '../../elements/img.lazy-image';
import {updateMargin} from './updateMargin';
import {recognizeFavourites} from '../../elements/a.favourite';

export const renderComplexesLists = ( complexesLists, data, isLoadButtonCheckNeeded, isDataCheckNeeded ) => {
	Array.from( complexesLists ).forEach( ( it ) => {
		const complexId = it.dataset.complex ? it.dataset.complex : Object.keys( data.complexes )[0];
		const currentComplexData = data.complexes[complexId];

		if ( isDataCheckNeeded && ( !currentComplexData || !currentComplexData.rendered ) )
		{
			it.style.display = 'none';
			
			return;
		}

		it.style.display = '';
		clearList( it );
		it.classList.add( 'with-lazy-images' );
		it.querySelector( 'li.more' ).insertAdjacentHTML( 'beforebegin', currentComplexData.rendered );
		initLazyImages();

		if ( isLoadButtonCheckNeeded )
		{
			checkLoadButton( it.querySelector( 'button.load-more' ), currentComplexData.rooms_left || data.rooms_left, data.next_page );
		}
	} );

	recognizeFavourites();
	updateMargin();
}
